import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Token from '../views/Token.vue'
import SelectFridge from '../views/SelectFridge.vue'
import TestLock from '../views/TestLock.vue'
import TestRfid from '../views/TestRfid.vue'
import TestScales from '../views/TestScales.vue'
import TestScalesShelf from '../views/TestScalesShelf.vue'
import CalibrateScalesShelf from '../views/CalibrateScalesShelf.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/token',
        name: 'token',
        component: Token,
    },
    {
        path: '/select_fridge',
        name: 'select_fridge',
        component: SelectFridge,
    },
    {
        path: '/test_lock',
        name: 'test_lock',
        component: TestLock,
    },
    {
        path: '/test_rfid',
        name: 'test_rfid',
        component: TestRfid,
    },
    {
        path: '/test_scales',
        name: 'test_scales',
        component: TestScales,
    },
    {
        path: '/test_scales_shelf',
        name: 'test_scales_shelf',
        component: TestScalesShelf,
    },
    {
        path: '/calibrate_scales_shelf/:shelf/:rack',
        name: 'calibrate_scales_shelf',
        component: CalibrateScalesShelf,
        props: true,
    },
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
